import { coreService } from "../../../services/coreService";
import { buildQuery } from "../../../lib/network";

export type BackgroundJob = Awaited<ReturnType<ReturnType<typeof getBackgroundJob>>>;

export const getBackgroundJob = (headers: any) => (id: string) => {
  return buildQuery(coreService.backgroundJobsDetail(parseInt(id), { headers }), (response) => {
    return response.data;
  });
};

export const getActiveJobs =
  (headers: any, jobMonitorOnly: boolean = false) =>
  () => {
    return buildQuery(coreService.backgroundJobsActiveJobsList({ jobMonitorOnly }, { headers }), (response) => {
      return response.data.map((job) => {
        return {
          ...job,
          createdAt: new Date(job.createdAt),
          startedAt: job.startedAt ? new Date(job.startedAt) : null,
          endedAt: job.endedAt ? new Date(job.endedAt) : null,
          cancelRequestedAt: job.cancelRequestedAt ? new Date(job.cancelRequestedAt) : null,
          jobDetails: job.jobDetails as any,
          results: job.results as any,
        };
      });
    });
  };

export const getActiveJobTypes = (headers: any) => () => {
  return buildQuery(coreService.backgroundJobsActiveJobTypesList({ headers }), (response) => {
    return response.data;
  });
};

export const getJobHistory =
  (
    headers: any,
    data?: {
      createdAfter?: string;
      createdBefore?: string;
      jobType?: "imports" | "giscopy" | "doc-gen" | "gis-spatial-reference-update" | "csv-export";
    },
  ) =>
  () => {
    const jobType = data?.jobType;
    const jobTypeObject = jobType?.trim() ? { jobType: jobType } : {};
    return buildQuery(
      coreService.backgroundJobsList(
        {
          createdAfter: data?.createdAfter,
          createdBefore: data?.createdBefore,
          ...jobTypeObject,
        },
        { headers },
      ),
      (response) => {
        return response.data;
      },
    );
  };

export const cancelJob = (headers: any) => (jobId: number | string) => {
  return buildQuery(
    coreService.backgroundJobsCancelJobUpdate({ coreBackgroundJobId: Number(jobId) }, { headers }),
    (response) => {
      return response.data;
    },
  );
};

export type BackgroundJobResults = Awaited<ReturnType<ReturnType<typeof getJobResultsAsync>>>;

export const getJobResultsAsync = (headers: any) => (jobId: number | string) => {
  return buildQuery(coreService.backgroundJobsResultsCreate({ id: Number(jobId) }, { headers }), async (response) => {
    return response.data;
  });
};

export const getJobResultsSync = (headers: any) => (jobId: number | string) => {
  return buildQuery(coreService.backgroundJobsResultsCreate({ id: Number(jobId) }, { headers }), (response) => {
    return response.data;
  });
};
